import moment from "moment"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { getAllMobileNotificationHistory, getSpecificMobileNotificationHistory, setNotificationActiveTab, setNotificationHistoryItemToFilled, setNotificationHistoryItemToFilledSpecific } from "../../features/admin4/admin4Slice"
import { MdKeyboardArrowRight } from "react-icons/md";
import Pagination from "../shared/Pagination"
import { menuOptions, subMenuOptions } from '../../utils/bildirimOptions'
import { scrollToTop } from "../../helper/scrollToTop"
import { toast } from "react-toastify"

const Container = styled.div`
    width: 100%;
    padding: 30px;

    .content-container{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 40px;


        .content-side{
            width: calc(50% - 20px);
            background-color: ${({theme}) => theme.secondaryBgColor};
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 10px;
            padding: 20px;
            gap: 20px;
            color: ${({theme}) => theme.mainTextColor};


            .side-top{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }

            .notification-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 100%;

                .date-grp-container{
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .date{
                        width: 100%;
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                        padding-bottom: 5px;
                        margin-bottom: 10px;
                    }

                    .list{
                        display: flex;
                        flex-direction: column;
                        gap: 20px;

                        .list-item{
                            display: flex;
                            flex-direction: column;
                            gap: 10px;
                            width: 100%;
                            padding-bottom: 20px;
                            border-bottom: 1px solid ${({theme}) => theme.mainBgColor};

                            .list-item-part{
                                display: flex;
                                justify-content: space-between !important;
                                align-items: center;

                                .list-item-part-grp{
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                    font-size: var(--font-size-sm);

                                &:last-child{
                                    align-items: flex-start;
                                }
                                
                                .key{
                                    font-weight: var(--font-weight-lg);
                                    display: flex;
                                    align-items: center;
                                    gap: 5px;

                                    .arr-icon{
                                        font-size: 1.2rem;
                                    }
                                }

                                .value{
                                    font-weight: var(--font-weight-md);
                                }

                                .btn{
                                    border: 1px solid var(--color-main);
                                    padding: 5px 10px;
                                    border-radius: 5px;
                                    color: var(--color-main);
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-xl);
                                }
                                }
                            }

                            .phone-number-container{
                                display: flex;
                                flex-wrap: wrap;
                                gap: 10px;

                                .phone-number-item{
                                    font-size: var(--font-size-sm);
                                    font-weight: var(--font-weight-lg);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

const MobileNotificationHistory = () => {

    const {

        allMobileNotificationHistoryList,
        isLoadingGetAllMobileNotificationHistory,
        allMobileNotificationHistoryCount,

        specificMobileNotificationHistoryList,
        isLoadingGetSpecificMobileNotificationHistory,
        specificMobileNotificationHistoryCount,

    } = useSelector(state => state.admin4)

    const dispatch = useDispatch()

    const [currentPageAll, setCurrentPageAll] = useState(1)
    const [currentPageSpecific, setCurrentPageSpecific] = useState(1)

    
  const itemsPerPage = 50;
  const totalPagesAll = Math.ceil(allMobileNotificationHistoryCount / itemsPerPage);
  const totalPagesSpecific = Math.ceil(specificMobileNotificationHistoryCount / itemsPerPage);

    const [showNumberClickIndex, setShowNumberClickIndex] = useState(null)

    useEffect(() => {
        dispatch(getAllMobileNotificationHistory({page:currentPageAll}))
        dispatch(getSpecificMobileNotificationHistory({page:currentPageSpecific}))
    },[currentPageAll, currentPageSpecific])


    const handleNotificationHistoryItemToFilled = (historyItem, type) => {

        const notificationTitle = historyItem.messageTitle
        const notificationText = historyItem.messageText

        const notificationMenu = menuOptions.find(menuItem => {
            return menuItem.value === historyItem.menuName
        })
        const notificationSubMenu = subMenuOptions.find(subMenuItem => {
            return subMenuItem.value === historyItem.subMenuName
        }) || {
            id: "",
            text: "",
            value: ""
          }

        if(type === "all"){

            dispatch(setNotificationActiveTab(1))
            dispatch(setNotificationHistoryItemToFilled({
                notificationTitle,
                notificationText,
                notificationMenu,
                notificationSubMenu
            }))
        }

        else{
            dispatch(setNotificationActiveTab(2))
            dispatch(setNotificationHistoryItemToFilledSpecific({
                notificationTitle,
                notificationText,
                notificationMenu,
                notificationSubMenu,
                selectedPhoneNumbers: historyItem.notificationRecipients.$values.map(item => {
                    return{
                        username: item.userName,
                        phoneNumber: item.phoneNumber
                    }
                })
            }))
        }

        toast.success('Bildirim verileri inputlara başarılı bir şekilde aktarıldı.', {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    

  return (
    <Container>
        <div className="content-container">

            <div className="content-side">
                <div className="side-top">Herkese Gönderilen Bildirim Geçmişi</div>
                <div className="notification-list">

                    {
                        allMobileNotificationHistoryList.map((item) => (
                            <div className="date-grp-container">
                                <div className="date">{moment(item.createdAt).format("L")}</div>
                                <div className="list">
                                    {
                                        item.data.map((historyItem) =>(
                                            <div className='list-item'>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderilme Tarihi:</div>
                                                        <div className="value">{moment(item.createdAt).format("HH:mm")}</div>
                                                    </div>
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderen Kullanıcı:</div>
                                                        <div className="value">{historyItem.createrUserName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key"> Menu:</div>
                                                        <div className="value">{historyItem.menuName}</div>
                                                    </div>
                                                
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Alt Menü:</div>
                                                        <div className="value">{historyItem.subMenuName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Başlığı:</div>
                                                        <div className="value">{historyItem.messageTitle}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Metni:</div>
                                                        <div className="value">{historyItem.messageText}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <button className="btn" onClick={() => {handleNotificationHistoryItemToFilled(historyItem, "all"); scrollToTop(200)}}>Bu Bildirimi Tekrarla</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                            </div>

                        ))
                    }
                </div>
                {(allMobileNotificationHistoryList || allMobileNotificationHistoryList?.length > 0) && (
                    <Pagination
                    totalPages={totalPagesAll}
                    handleClick={setCurrentPageAll}
                    currentPage={currentPageAll}
                    />
                )}

            </div>

            <div className="content-side">
                <div className="side-top">Telefon Numarasına Göre Gönderilen Bildirim Geçmişi</div>

                <div className="notification-list">
                    {
                        specificMobileNotificationHistoryList.map((item) => (
                            <div className="date-grp-container">
                                <div className="date">{moment(item.createdAt).format("L")}</div>
                                <div className="list">
                                    {
                                        item.data.map((historyItem, i) =>(
                                            <div className='list-item'>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderilme Tarihi:</div>
                                                        <div className="value">{moment(historyItem.createdAt).format("HH:mm")}</div>
                                                    </div>
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Gönderen Kullanıcı:</div>
                                                        <div className="value">{historyItem.createrUserName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key"> Menu:</div>
                                                        <div className="value">{historyItem.menuName}</div>
                                                    </div>
                                                
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Alt Menü:</div>
                                                        <div className="value">{historyItem.subMenuName}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Başlığı:</div>
                                                        <div className="value">{historyItem.messageTitle}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <div className="key">Bildirim Metni:</div>
                                                        <div className="value">{historyItem.messageText}</div>
                                                    </div>
                                                </div>
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp" style={{cursor: "pointer"}}>
                                                        <div className="key" onClick={() => setShowNumberClickIndex(showNumberClickIndex === historyItem.id ? null : historyItem.id)} style={{textDecoration: "underline"}}>Gönderilen Numaralar <MdKeyboardArrowRight className="arr-icon"/></div>
                                                        <div className="value"></div>
                                                    </div>
                                                </div>
                                                {
                                                    showNumberClickIndex === historyItem.id &&
                                                    <div className="phone-number-container">
                                                        {
                                                            historyItem.notificationRecipients.$values.map(item => (
                                                                <div className="phone-number-item">{item.phoneNumber} - {item.userName}</div>
                                                            ))
                                                        }
                                                    </div>
                                                }
                                                <div className="list-item-part">
                                                    <div className="list-item-part-grp">
                                                        <button className="btn" onClick={() => {handleNotificationHistoryItemToFilled(historyItem, "specific"); scrollToTop(200)}}>Bu Bildirimi Tekrarla</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                {(specificMobileNotificationHistoryList || specificMobileNotificationHistoryList?.length > 0) && (
                    <Pagination
                    totalPages={totalPagesSpecific}
                    handleClick={setCurrentPageSpecific}
                    currentPage={currentPageSpecific}
                    />
                )}
            </div>

        </div>

    </Container>
  )
}

export default MobileNotificationHistory